
import './App.css';
import MainPage from './page1';

function App() {
  return (
    <div className="App">
      <MainPage/>
    </div>
  );
}

export default App;
